import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  saveImage,
  saveScenesToLocalStorage,
  saveScenesToStorage
} from "./utils";

class Header extends Component {
  constructor(props) {
    super(props);
    this.saveImage = saveImage.bind(this);
    this.saveScenesToLocalStorage = saveScenesToStorage.bind(this);

    this.state = {
      modal: false,
      download: {
        format: "png",
        scene: ""
      }
    };
    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
    this.downloadImage = this.downloadImage.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }
  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    var download = this.state.download;
    download[name] = value;
    this.setState({
      download
    });
  }
  downloadImage() {
    const { format, scene } = this.state.download;
    this.saveImage({ format, scene });
    this.toggle();
  }

  render() {
    return (
      <div id="header" style={{ top: "0px" }}>
        <div className="section menu">
          <nav className="ill-menu-bar">
            <ul className="ill-menu ill-menu-root">
              <li className="ill-menu-item ill-menu-item-menu ill-hover">
                <span
                  className="ill-menu-item-icon"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-caption">File</span>
                <span
                  className="ill-menu-item-shortcut"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-tail" />
              </li>
              <li className="ill-menu-item ill-menu-item-menu ill-hover">
                <span
                  className="ill-menu-item-icon"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-caption">Edit</span>
                <span
                  className="ill-menu-item-shortcut"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-tail" />
              </li>
              <li className="ill-menu-item ill-menu-item-menu ill-hover">
                <span
                  className="ill-menu-item-icon"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-caption">Modify</span>
                <span
                  className="ill-menu-item-shortcut"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-tail" />
              </li>
              <li className="ill-menu-item ill-menu-item-menu ill-hover">
                <span
                  className="ill-menu-item-icon"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-caption">View</span>
                <span
                  className="ill-menu-item-shortcut"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-tail" />
              </li>
              <li className="ill-menu-item ill-menu-item-menu ill-hover">
                <span
                  className="ill-menu-item-icon"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-caption">Help</span>
                <span
                  className="ill-menu-item-shortcut"
                  style={{ display: "none" }}
                />
                <span className="ill-menu-item-tail" />
              </li>
            </ul>
          </nav>
        </div>
        <div className="section persona">
          <div className="ill-persona-bar">
            <div className="ill-persona-container" />
          </div>
        </div>
        <button
          className="saveImage ill-button"
          title="Download image"
          onClick={this.toggle}
        >
          Download
        </button>
        <button
          className="saveImage ill-button"
          title="Save scenes"
          disabled={this.props.scenes ? false : true}
          onClick={this.saveScenesToLocalStorage.bind(this, this.props.scenes)}
        >
          Save
        </button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className="download-card"
        >
          <ModalHeader toggle={this.toggle}>Download Design</ModalHeader>
          <ModalBody>
            <select
              onChange={this.onChange}
              name="scene"
              className="custom-select"
            >
              {this.props.scenes ? (
                this.props.scenes.map((obj, key) => {
                  return (
                    <option value={key} key={key}>
                      {obj.name}
                    </option>
                  );
                })
              ) : (
                <option value="0"> Scene 1</option>
              )}
            </select>
            <select
              onChange={this.onChange}
              name="format"
              className="custom-select"
            >
              <option value="png">PNG</option>
              <option value="jpg">JPG</option>
              <option disabled value="pdf">
                PDF
              </option>
              <option disabled value="svg">
                SVG
              </option>
            </select>
          </ModalBody>
          <ModalFooter>
            <Button className="" color="primary" onClick={this.downloadImage}>
              Download
            </Button>{" "}
            <Button color="secondary" onClick={this.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <div className="section windows">
          <div className="tabs">
            <div className="tab ill-active">
              <span className="title">Untitled*</span>
              <span className="close">✕</span>
            </div>
          </div>
        </div>
        <div
          className="section busy"
          style={{ display: "none", color: "rgb(215, 46, 99)" }}
        >
          <span className="txt" style={{ marginRight: "4px" }}>
            Checking connectivity...
          </span>
          <span
            style={{
              borderWidth: "4px",
              borderStyle: "solid",
              borderColor:
                "rgb(215, 46, 99) rgb(243, 243, 243) rgb(243, 243, 243)",
              borderIimage: "initial",
              borderRadius: "50%",
              width: "6px",
              height: "6px",
              animation: "spin 2s linear 0s infinite normal none running"
            }}
          />
        </div>
        <div className="section login user" has-been-clicked="no">
          <div
            className="avatar user-avatar"
            style={{
              backgroundImage:
                'url("https://dey61q2n7fveq.cloudfront.net/avatars/5HzLPMCoi")'
            }}
          />
          <div className="username">
            <span>Oyetoke</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
